import { DEFAULTS } from "./defaults.js";
import { VERTICAL_EMBED_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers-lazy.js";
const pluginVerticalEmbed = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: VERTICAL_EMBED_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginVerticalEmbed
};
//# sourceMappingURL=viewer-lazy.js.map
